import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Button,  Link } from '@synergycms_core/components/generic';
import styleFile from './myReservation.js';

class MyReservation extends React.Component {
  static displayName = 'MyReservation';

  isMobile = () => {

    return this.props.theme.deviceType !== 'DESK';
  };
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { myBookingUrl } = config;
    const isFunction = is(Function, myBookingUrl)
    return (
      <div className={classes.moreOptions}>
        <div className={classes.moreOptionsFlex}>

          { isFunction ? (
            <div className={classes.miReservationMobile}>
              <Button
                onClick={myBookingUrl}
                innerStyle={classes.reservationButton}
                richText={{
                  ucFirst: true,
                  text: '_%mi reserva%_',
                  translate: true,
                  icon: { unicodeContent: 'e000', innerStyle: classes.reservationButtonArrow },
                  rightIcon: { unicodeContent: 'e087', innerStyle: classes.reservationButtonIcon }
                }}
              />
            </div>
              ): (
            <div className={classes.miReservationMobile}>
               <Link
                  innerStyle={classes.reservationButton}
                  richText={{
                    ucFirst: true,
                    text: '_%mi reserva%_',
                    translate: true,
                    icon: { unicodeContent: 'e000', innerStyle: classes.reservationButtonArrow },
                    rightIcon: { unicodeContent: 'e087', innerStyle: classes.reservationButtonIcon }
                  }}
                  href={myBookingUrl}
                  target={'_self'}
                />
             
            </div>
          )}
        </div>

      </div>
    );
  }
}

export default compose(
  PropertyManager(['myBookingUrl']),
  withThemeJSS({ styleFile, link: true, index: 100 })
)(MyReservation);
